import { DefaultDeliveryNoteModel } from './public-tracking.model';

export interface DeliveryNoteErpView extends DefaultDeliveryNoteModel {
  numberOfHUs: number;
}

export interface ErpTrackingPayload {
  deliveryNoteNumber?: string;
  orderNumber?: string;
  salesOrganization?: string;
}
